import { ThemeApi } from '../api/themeApi'

export const FETCH_THEMES = 'FETCH_THEMES'
export const FETCH_THEMES_SUCCESS = 'FETCH_THEMES_SUCCESS'
export const FETCH_THEMES_ERROR = 'FETCH_THEMES_ERROR'

export const FETCH_THEME = 'FETCH_THEME'
export const FETCH_THEME_SUCCESS = 'FETCH_THEME_SUCCESS'
export const FETCH_THEME_ERROR = 'FETCH_THEME_ERROR'

export const UPDATE_THEME = 'UPDATE_THEME'
export const UPDATE_THEME_SUCCESS = 'UPDATE_THEME_SUCCESS'
export const UPDATE_THEME_ERROR = 'UPDATE_THEME_ERROR'

export const PUBLISH_THEME = 'PUBLISH_THEME'
export const PUBLISH_THEME_SUCCESS = 'PUBLISH_THEME_SUCCESS'
export const PUBLISH_THEME_ERROR = 'PUBLISH_THEME_ERROR'

export const CREATE_THEME = 'CREATE_THEME'
export const CREATE_THEME_SUCCESS = 'CREATE_THEME_SUCCESS'
export const CREATE_THEME_ERROR = 'CREATE_THEME_ERROR'

export const DELETE_THEME = 'DELETE_THEME'
export const DELETE_THEME_SUCCESS = 'DELETE_THEME_SUCCESS'
export const DELETE_THEME_ERROR = 'DELETE_THEME_ERROR'

export const UNPUBLISH_THEME = 'UNPUBLISH_THEME'
export const UNPUBLISH_THEME_SUCCESS = 'UNPUBLISH_THEME_SUCCESS'
export const UNPUBLISH_THEME_ERROR = 'UNPUBLISH_THEME_ERROR'

const getErrorMessage = (error, fallback) =>
  error?.response?.data?.message || fallback

export const fetchThemes = () => async (dispatch) => {
  dispatch({ type: FETCH_THEMES })

  try {
    const response = await ThemeApi.fetchThemes()
    dispatch({ type: FETCH_THEMES_SUCCESS, payload: response.data })
  } catch (error) {
    dispatch({
      type: FETCH_THEMES_ERROR,
      payload: getErrorMessage(error, 'Failed to fetch themes'),
    })
    throw error
  }
}

export const fetchTheme = (id) => async (dispatch) => {
  dispatch({ type: FETCH_THEME })

  try {
    const response = await ThemeApi.fetchTheme(id)
    dispatch({ type: FETCH_THEME_SUCCESS, payload: response.data })
  } catch (error) {
    dispatch({
      type: FETCH_THEME_ERROR,
      payload: getErrorMessage(error, 'Failed to fetch theme'),
    })
    throw error
  }
}

export const createTheme = (data) => async (dispatch) => {
  dispatch({ type: CREATE_THEME })

  try {
    const response = await ThemeApi.createTheme(data)
    dispatch({ type: CREATE_THEME_SUCCESS, payload: response.data })
    return response.data
  } catch (error) {
    dispatch({
      type: CREATE_THEME_ERROR,
      payload: getErrorMessage(error, 'Failed to create theme'),
    })
    throw error
  }
}

export const updateTheme = (id, data) => async (dispatch) => {
  dispatch({ type: UPDATE_THEME })

  try {
    const response = await ThemeApi.updateTheme(id, data)
    dispatch({ type: UPDATE_THEME_SUCCESS, payload: response.data })
    return response.data
  } catch (error) {
    dispatch({
      type: UPDATE_THEME_ERROR,
      payload: getErrorMessage(error, 'Failed to update theme'),
    })
    throw error
  }
}

export const publishTheme = (id) => async (dispatch) => {
  dispatch({ type: PUBLISH_THEME })

  try {
    const response = await ThemeApi.publishTheme(id)
    dispatch({ type: PUBLISH_THEME_SUCCESS, payload: response.data })
    return response.data
  } catch (error) {
    dispatch({
      type: PUBLISH_THEME_ERROR,
      payload: getErrorMessage(error, 'Failed to publish theme'),
    })
    throw error
  }
}

export const deleteTheme = (id) => async (dispatch) => {
  dispatch({ type: DELETE_THEME })

  try {
    await ThemeApi.deleteTheme(id)
    dispatch({ type: DELETE_THEME_SUCCESS, payload: { id } })
  } catch (error) {
    dispatch({
      type: DELETE_THEME_ERROR,
      payload: getErrorMessage(error, 'Failed to delete theme'),
    })
    throw error
  }
}

export const unpublishTheme = (id) => async (dispatch) => {
  dispatch({ type: UNPUBLISH_THEME })

  try {
    const response = await ThemeApi.unpublishTheme(id)
    dispatch({ type: UNPUBLISH_THEME_SUCCESS, payload: response.data })
    return response.data
  } catch (error) {
    dispatch({
      type: UNPUBLISH_THEME_ERROR,
      payload: getErrorMessage(error, 'Failed to unpublish theme'),
    })
    throw error
  }
}